// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__eG6Wl","label":"Input_label___a58j"};